<template>
    <Modal id="clover-terminals-modal"
           icon="fa-solid fa-tablet"
           :title="title">
        <div v-if="errorMessage"
             class="alert alert-danger">
            <p>{{ errorMessage }}</p>
        </div>

        <PageLoadingSpinner v-if="loading"></PageLoadingSpinner>

        <div v-if="!errorMessage && !loading">
            <table class="table table-striped text-left table--valign-middle">
                <thead>
                    <tr>
                        <th>{{ l('CLOVER_SETTINGS.TERMINALS_TID') }}</th>
                        <th>{{ l('CLOVER_SETTINGS.TERMINALS_NAME') }}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="terminal in terminals"
                        :key="terminal.lineNumber">
                        <td>{{ terminal.serial }}</td>
                        <td>{{ terminal.name }}</td>
                        <td class="text-right">
                            <button v-if="terminal.serial !== xCloverDeviceId"
                                    class="btn btn-primary"
                                    @click="selectTerminal(terminal.serial)">
                                {{ l('CLOVER_SETTINGS.TERMINALS_SELECT') }}
                            </button>
                            <span v-if="terminal.serial === xCloverDeviceId">
                                <em class="no-wrap">
                                    {{ l('CLOVER_SETTINGS.CURRENT_TERMINAL') }}
                                </em>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn size="lg"
                           class="cancel-btn"
                           @click="cancel">
                    {{ l('CANCEL') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'CloverTerminalsModal',

    components: { SquareBtn, Modal, PageLoadingSpinner },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        title: {
            type: String,
            default: 'CLOVER_SETTINGS.TERMINALS_TITLE',
        },
        icon: {
            type: String,
            default: 'fa-rectangle-list',
        },
        xCloverDeviceId: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            loading: true,
            terminals: [],
            errorMessage: null,
        };
    },

    created() {
        try {
            container.cloverDriver.init(false);
            container.cloverDriver.getTerminalList()
                .then((data) => {
                    this.terminals = data;
                }).catch((error) => {
                    this.errorMessage = error.message;
                })
                .finally(() => {
                    this.loading = false;
                });
        } catch (error) {
            this.errorMessage = error.message;
            this.loading = false;
        }
    },

    methods: {
        async selectTerminal(xCloverDeviceId) {
            container.dialogService
                .confirm('CLOVER_SETTINGS.TERMINALS_SELECT_CONFIRM')
                .then((confirmed) => {
                    if (confirmed) {
                        return this.resolve(xCloverDeviceId);
                    }
                    // The user cancelled
                    return null;
                });
        },
    },
};
</script>
